(function () {
  'use strict';

  let angular = window.angular;

  ResendActivationModalController.$inject = ['AppUtils', '$translate'];

  angular.module('app').component('resendActivationModal', {
    template:'<div ng-style="{opacity: ctrl.loading ? 0 : 1}"><div ng-if="ctrl.state === \'confirm\'"><div class="modal-header"><span translate>entities.user.status.resendActivation</span></div><div class="modal-body text-center paddingTB20"><p class="marginB10" translate-values="{email: ctrl.user.email}" translate>entities.user.status.resendConfirm</p><p class="text-muted no-margin" style="font-size: 12px" translate>entities.user.status.resendExplain</p></div><div class="modal-footer"><button class="btn btn-default pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-click="ctrl.confirmSend()" translate>buttons.accept</button></div></div><div ng-if="ctrl.state === \'success\'" class="modal-body text-center paddingTB20"><h3 class="text-success no-margin"><i class="far fa-check-circle fa-fw fa-2x"></i></h3><p class="marginT10 marginB0" translate>entities.user.status.resendSuccess</p></div><div ng-if="ctrl.state === \'error\'" class="modal-body text-center paddingTB20"><h3 class="text-warning no-margin"><i class="fas fa-exclamation-triangle fa-fw fa-2x"></i></h3><p class="marginT10 marginB0">{{ctrl.errorMessage}}</p></div><div ng-if="ctrl.state === \'success\' || ctrl.state === \'error\'" class="modal-footer text-center"><button class="btn btn-primary" ng-click="ctrl.close()" translate>buttons.accept</button></div></div><spinner show="ctrl.loading" show-logo="true" css-class="\'small\'"></spinner>',
    controller: ResendActivationModalController,
    controllerAs: 'ctrl',
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function ResendActivationModalController (utils, $translate) {
    let vm = this;

    vm.$onInit = function onInit() {
      vm.user = vm.resolve.user;
      vm.state = 'confirm';
      vm.loading = false;
      vm.confirmSend = confirmSend;
      vm.close = close;
    };

    function confirmSend () {
      vm.loading = true;
      vm.resolve.model
        .verifyAccount({ email: vm.user.email })
        .$promise
        .then(function () {
          vm.loading = false;
          vm.state = 'success';
        })
        .catch(function (err) {
          vm.loading = false;
          const error = utils.getHTTPError(err);
          vm.errorMessage = error.message || $translate.instant('errors.UNKNOWN_ERROR');
          vm.state = 'error';
        });
    }

    function close () {
      vm.modalInstance.close(vm.state === 'success');
    }
  }
})();
